// i18next: RU + EN + ZH (упрощённый китайский), неймспейсы common/auth/game/shop/admin/politics, fallback EN + warning.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enAdmin from './locales/en/admin.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enGame from './locales/en/game.json';
import enPolitics from './locales/en/politics.json';
import enShop from './locales/en/shop.json';
import ruAdmin from './locales/ru/admin.json';
import ruAuth from './locales/ru/auth.json';
import ruCommon from './locales/ru/common.json';
import ruGame from './locales/ru/game.json';
import ruPolitics from './locales/ru/politics.json';
import ruShop from './locales/ru/shop.json';
import zhAdmin from './locales/zh/admin.json';
import zhAuth from './locales/zh/auth.json';
import zhCommon from './locales/zh/common.json';
import zhGame from './locales/zh/game.json';
import zhPolitics from './locales/zh/politics.json';
import zhShop from './locales/zh/shop.json';

export const LANGS = ['ru', 'en', 'zh'] as const;
export type Lang = (typeof LANGS)[number];
/** Языки с письмом справа налево (задел: арабский). */
const RTL = new Set(['ar', 'he', 'fa']);

export function isLang(v: unknown): v is Lang {
  return typeof v === 'string' && (LANGS as readonly string[]).includes(v);
}

/** Язык — выбранный игроком (на главной странице или в профиле); по умолчанию — русский. */
function detect(): Lang {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem('sk_lang');
  } catch {
    // приватный режим
  }
  return isLang(saved) ? saved : 'ru';
}

void i18n.use(initReactI18next).init({
  resources: {
    ru: { common: ruCommon, auth: ruAuth, game: ruGame, shop: ruShop, admin: ruAdmin, politics: ruPolitics },
    en: { common: enCommon, auth: enAuth, game: enGame, shop: enShop, admin: enAdmin, politics: enPolitics },
    zh: { common: zhCommon, auth: zhAuth, game: zhGame, shop: zhShop, admin: zhAdmin, politics: zhPolitics },
  },
  lng: detect(),
  fallbackLng: 'en',
  ns: ['common', 'auth', 'game', 'shop', 'admin', 'politics'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
  saveMissing: import.meta.env.DEV,
  missingKeyHandler: (lngs, ns, key) => {
    // Отсутствующий ключ → fallback EN + предупреждение в консоли
    console.warn(`[i18n] missing ${lngs.join(',')}:${ns}:${key}`);
  },
});

export function setLanguage(lang: Lang): void {
  try {
    localStorage.setItem('sk_lang', lang);
  } catch {
    // приватный режим
  }
  void i18n.changeLanguage(lang);
  applyDirection(lang);
}

export function applyDirection(lang: string): void {
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL.has(lang) ? 'rtl' : 'ltr';
}
applyDirection(i18n.language);

export default i18n;
